module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0100.jpg?v=35e0e0e1";